import { ApolloLink } from '@apollo/client';
import { asyncMap } from '@apollo/client/utilities';

declare global {
  interface Window {
    WhatapBrowserAgent?: {
      addCustomEvent: (
        eventName: string,
        option:
          | {
              contents: string | undefined;
              customDuration: number | undefined;
            }
          | undefined,
      ) => void;
      setUserID: (id: string) => void;
    };
  }
}
/**
 * Apollo Link that measures the duration of GraphQL requests and reports it to the APM system.
 * This link tracks how long each operation takes to complete and logs the duration along with
 * operation details for performance monitoring.
 */
export const requestDurationLink = new ApolloLink((operation, forward) => {
  // Record the start time when the request begins
  const startTimestamp = new Date();
  const operationName = operation.operationName || 'unnamed_operation';

  // Pass the operation to the next link in the chain
  return asyncMap(forward(operation), async (response) => {
    try {
      const endTimestamp = new Date();

      const duration = endTimestamp.getTime() - startTimestamp.getTime();

      // If the browser has the Whatap agent, also report to it
      if (typeof window !== 'undefined' && window.WhatapBrowserAgent) {
        if (response.errors && response.errors.length > 0) {
        } else {
        }
      }

      return response;
    } catch (error) {
      return response;
    }
  });
});
